import { createReducer, isAnyOf } from "@reduxjs/toolkit";

import {
  getPostDetails,
  getPostDetailsSuccess,
  getPostDetailsFailure,
  getPostDetailsReset,
  setCommentsCount,
  setSibilings,
} from "./actions";
import {
  likePostSuccess,
  unlikePostSuccess,
  updatePurchasedPost,
} from "../posts/actions";

// todo: add other post fields here
const initialState = {
  id: null,
  author: null,
  likesCount: null,
  commentsCount: null,
  isLiked: false,
  contentType: null,
  isLocked: false,
  accessType: null,
  isBlurredByReports: false,
  showBlurredPostAnywhere: false,
  isLoading: true,
  error: null,
  nextPostId: null,
  nextPostKey: null,
  prevPostId: null,
  prevPostKey: null,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getPostDetails.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(getPostDetailsSuccess.type, (state, action) => ({
      ...action.payload,
      nextPostId: state.nextPostId,
      nextPostKey: state.nextPostKey,
      prevPostId: state.prevPostId,
      prevPostKey: state.prevPostKey,
      isLoading: false,
      error: initialState.error,
    }))
    .addCase(updatePurchasedPost, (state, { payload }) => {
      return {
        ...state,
        ...payload.post,
        author: payload.post.author.id,
      };
    })
    .addCase(getPostDetailsFailure.type, (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }))
    .addCase(getPostDetailsReset.type, () => ({
      ...initialState,
    }))
    .addCase(setCommentsCount.type, (state, action) => ({
      ...state,
      commentsCount: action.payload,
    }))
    .addCase(setSibilings.type, (state, { payload }) => {
      const { nextPostId, nextPostKey, prevPostId, prevPostKey } = payload;

      state.nextPostId = nextPostId;
      state.prevPostId = prevPostId;
      state.nextPostKey = nextPostKey;
      state.prevPostKey = prevPostKey;
    })
    .addMatcher(
      isAnyOf(likePostSuccess, unlikePostSuccess),
      (state, { payload }) => {
        const { postId, likesCount } = payload;

        return {
          ...state,
          likesCount: postId === state.id ? likesCount : state.likesCount,
          isLiked: postId === state.id ? !state.isLiked : state.isLiked,
        };
      },
    );
});
